export const optimizelyPlugin = {
  install(Vue, optimizely) {
    Vue.prototype.$optimizelyClientInstance = optimizely;
    Vue.$optimizelyClientInstance = optimizely;
  }
};

export default optimizelyPlugin;
